import { ArrowPathIcon, ArrowRightOnRectangleIcon, XCircleIcon } from "@heroicons/react/24/outline";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { FC, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import logoImg from "../../../assets/images/logo.jpeg";
import {
  ButtonPrimary,
  ButtonSecondary
} from "../../../components";

import { clearState as clearStatePuAuth, signUpPuOss } from "modules/AuthPu/services/PuAuth";
import { getsDataNIBChecklist } from "modules/Pu/services/DataNIBChecklist";
import { clearState as clearStateOssAuth, refreshTokenOss, userInfoOss } from "../services/OssAuth";
import CardPengajuanPu from "./CardPengajuanPu";
import { createRegSelfdeclare, getsRegSelfdeclare } from "modules/Registration/services/RegistrationSelfdeclare";
import { createRegReguler, getsRegReguler } from "modules/Registration/services/RegistrationReguler";
import { createDataPuNIBOSS } from "modules/Pu/services/DataNIB";
import { clearState as clearStateDataNIBChecklist } from "modules/Pu/services/DataNIBChecklist";

export interface PageOssSubmissionProps {
  className?: string;
}

type OssSubmissionForm = {
  username: string;
  password: string;
};

const OssSubmission: FC<PageOssSubmissionProps> = ({ className = "" }) => {
  let navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [searchParams, setSearchParams] = useSearchParams();
  const _access_token = searchParams.get("access-token")
  const _refresh_token = searchParams.get("refresh_token")
  const _kd_id = searchParams.get("kd_izin")
  const _id_izin = searchParams.get("id_izin")

  const {
    dataRefreshTokenOss,
    isSuccessRefreshToken,
    dataUserInfoOss,
    isSuccessUserInfo,
    isError: isErrorRefreshToken,
    isFetching: isFetchingRefreshToken,
    isFetching: isFetchingUserInfo,
    errorMessage: errorMessageRefreshToken
  } = useAppSelector((state) => state.ossAuthSlice);

  const {
    dataUserPu,
    isSuccessSignUpPuOss,
    isError: isErrorSignUpPuOss,
    isFetching: isFetchingSignUpPuOss,
    errorMessage: errorMessageSignUpPuOss
  } = useAppSelector((state) => state.puAuthSlice);

  const {
    data: dataChecklist,
    isSuccess: isSuccessDataChecklist,
    isError: isErrorDataChecklist,
    isFetching: isFetchingDataChecklist,
    errorMessage: errorMessageDataChecklist
  } = useAppSelector((state) => state.pu);

  const {
    isSuccessCreateDataPuNIB,
    dataCreatePuNIB,
    isFetchingCreateDataPuNib,

    isErrorCreateDataPuNIB,
    isFetching: isFetchingInquiryNIB,
    errorMessage: errorMessageInquiryNIB
  } = useAppSelector((state) => state.inquiryNIB);

  const {
    dataRegSelfdeclare,
    listRegSelfdeclare,

    isSuccessCreateRegSelfdeclare,
    isSuccessGetsRegSelfdeclare,

    isErrorCreateRegSelfdeclare,

    isFetching: isFetchingReg,
    errorMessage: errorMessageReg
  } = useAppSelector((state) => state.registrationSelfdeclare);

  const {
    dataRegReguler,
    listRegReguler,

    isSuccessCreateRegReguler,
    isSuccessGetsRegReguler,

    isErrorCreateRegReguler,

    isFetching: isFetchingRegReguler,
    errorMessage: errorMessageRegSelfdeclare
  } = useAppSelector((state) => state.registrationReguler);


  useEffect(() => {

    async function checkRefreshToken() {
      if (_refresh_token) {
        dispatch(refreshTokenOss({
          refresh_token: _refresh_token
        }))
      }
    }

    checkRefreshToken();

  }, []);

  useEffect(() => {

    async function _checkUserInfoOss(access_token: string) {
      if (access_token !== "") {
        dispatch(userInfoOss({
          access_token: access_token
        }))
      }
    }

    async function _checkSignUpUserOss() {
      if (dataUserInfoOss.data.email !== "" && dataUserInfoOss.data.nama !== "") {
        dispatch(signUpPuOss({
          REGISTER: {
            emailAddr: dataUserInfoOss.data.email,
            nama: dataUserInfoOss.data.nama,
            role: "R.10",
            password: dataUserInfoOss.data.email,
          }
        }))
      }
    }

    async function _getsDataNIBChecklist() {
      if (_kd_id !== "" && _id_izin !== "") {
        dispatch(getsDataNIBChecklist({
          pagination: {
            page: 1,
            perPage: 10,
          },
          filter: {
            id_izin: _id_izin,
            kd_izin: _kd_id
          }
        }))
      }
    }

    async function _createDataPuNIBOSS() {
      if (dataChecklist && dataUserPu) {
        dispatch(createDataPuNIBOSS({
          CREATE_PU: {
            IdIzin: _id_izin,
            KdIzin: _kd_id,
            UnikId: dataUserPu.REGISTER.data.unik_id,
          }
        }))
      }
    }

    async function _getsRegistrasiSeldeclare() {
      if (dataChecklist) {
        if (dataUserPu.REGISTER.data.unik_id && dataChecklist.GETS_DATANIBCHECKLIST.data[0].dataProdukHalal.kodeKlasifikasiProduk) {
          dispatch(getsRegSelfdeclare({
            pagination: {
              page: 1,
              perPage: 20
            },
            filter: {
              IdPu: dataUserPu.REGISTER.data.unik_id,
              JenisProduk: dataChecklist.GETS_DATANIBCHECKLIST.data[0].dataProdukHalal.kodeKlasifikasiProduk,
            }
          }))
        }

      }
    }

    async function _getsRegistrasiReguler() {
      if (dataChecklist) {
        if (dataUserPu.REGISTER.data.unik_id && dataChecklist.GETS_DATANIBCHECKLIST.data[0].dataProdukHalal.kodeKlasifikasiProduk) {

          dispatch(getsRegReguler({
            pagination: {
              page: 1,
              perPage: 20
            },
            filter: {
              IdPu: dataUserPu.REGISTER.data.unik_id,
              JenisProduk: dataChecklist.GETS_DATANIBCHECKLIST.data[0].dataProdukHalal.kodeKlasifikasiProduk,
            }
          }))
        }
      }
    }

    if (isSuccessRefreshToken) {
      dispatch(clearStateOssAuth({}))
      _checkUserInfoOss(dataRefreshTokenOss.data.access_token)
    }

    if (isSuccessUserInfo) {
      dispatch(clearStateOssAuth({}))
      _checkSignUpUserOss()
    }

    if (isSuccessSignUpPuOss) {
      dispatch(clearStatePuAuth({}))
      _getsDataNIBChecklist()
    }

    if (isSuccessDataChecklist) {
      dispatch(clearStateDataNIBChecklist({}))
      if (dataChecklist) {
        _createDataPuNIBOSS()
      }
    }

    if (isSuccessCreateDataPuNIB) {
      if (dataChecklist) {
        if (dataChecklist.GETS_DATANIBCHECKLIST.data[0].dataProdukHalal.flagSelfDeclare === "1") {
          _getsRegistrasiSeldeclare()
        } else {
          _getsRegistrasiReguler()
        }
      }
    }

  }, [isSuccessRefreshToken, isSuccessUserInfo, isSuccessSignUpPuOss, isSuccessDataChecklist, isSuccessCreateDataPuNIB]);

  const doOssSubmission = () => {

    console.log(dataChecklist.GETS_DATANIBCHECKLIST.data)

    if (dataChecklist.GETS_DATANIBCHECKLIST.data) {
      let kbli = "";
      let selfdeclare = "";
      let jenisProduk = "";
      let idIzin = "";
      let idProyek = "";
      let idProduk = "";
      let fOss = 1;

      dataChecklist.GETS_DATANIBCHECKLIST.data.forEach(element => {
        selfdeclare = element.dataProdukHalal.flagSelfDeclare;
        jenisProduk = element.dataProdukHalal.kodeKlasifikasiProduk;
        idIzin = element.idIzin
        idProyek = element.idProyek

        element.dataProdukHalal.listProduk.forEach(produk => {
          kbli = produk.kbli;
          idProduk = produk.idProduk;
        })
      });

      if (selfdeclare) {
        dispatch(createRegSelfdeclare({
          CREATE_REGISTRATION: {
            Kbli: kbli,
            UnikId: dataUserPu.REGISTER.data.unik_id,
            JenisProduk: jenisProduk,
            IdIzin: idIzin,
            IdProduk: idProduk,
            IdProyek: idProyek,
            FOss: fOss
          }
        }))
      } else {
        dispatch(createRegReguler({
          CREATE_REGISTRATION: {
            Kbli: kbli,
            UnikId: dataUserPu.REGISTER.data.unik_id,
            JenisProduk: jenisProduk,
            IdIzin: idIzin,
            IdProduk: idProduk,
            IdProyek: idProyek,
            FOss: fOss
          }
        }))
      }
    };
  };

  const doSelanjutnnyya = () => {
    if (isSuccessCreateRegSelfdeclare) {
      window.location.replace(`${process.env.REACT_APP_ASP_URL}/auth?grant=SSO&username=${dataUserPu.REGISTER.data.userid}&id_reg=${dataRegSelfdeclare.CREATE_REGISTRATION
        // window.location.replace(`https://test.halal.go.id/auth?grant=SSO&username=${dataUserInfoSaliha.data.email}&id_reg=${dataRegSelfdeclare.CREATE_REGISTRATION
        .data.IdReg}&channel_id=CH003`);
    }

    if (isSuccessCreateRegReguler) {
      window.location.replace(`${process.env.REACT_APP_ASP_URL}/auth?grant=SSO&username=${dataUserPu.REGISTER.data.userid}&id_reg=${dataRegReguler.CREATE_REGISTRATION
        // window.location.replace(`https://test.halal.go.id/auth?grant=SSO&username=${dataUserInfoSaliha.data.email}&id_reg=${dataRegSelfdeclare.CREATE_REGISTRATION
        .data.IdReg}&channel_id=CH001`);
    }

  }

  const doEditSelanjutnnya_selfdeclare = (idReg: number) => {
    window.location.replace(`${process.env.REACT_APP_ASP_URL}/auth?grant=SSO&username=${dataUserPu.REGISTER.data.userid}&id_reg=${idReg}&channel_id=CH003`);
  }

  const doEditSelanjutnnya_reguler = (idReg: number) => {
    window.location.replace(`${process.env.REACT_APP_ASP_URL}/auth?grant=SSO&username=${dataUserPu.REGISTER.data.userid}&id_reg=${idReg}&channel_id=CH001`);
  }

  const doLogout = () => {
    // dispatch(signOut({}));
  }

  const checkUserOss = () => {
    return (
      <ButtonSecondary
        // disabled={!client}
        loading={true}
        className="w-full"
        // sizeClass="px-2 py-1 sm:px-1"
        type="button"
      // onClick={() => doSelanjutnnyya()}
      >
        Mohon Tunggu
      </ButtonSecondary>
    )
  }

  const clientReject = () => {
    return (
      <>
        <div className="my-5"></div>
        <div
          className="p-1 text-xs rounded-full bg-red-300 items-center text-gray-800 leading-none lg:rounded-full flex lg:inline-flex"
          role="alert">
          <span className="flex mr-3">
            <XCircleIcon className="w-5 text-red-500" />
          </span>
          <span className="font-semibold mr-2 text-left flex-auto">
            Akses ditolak
          </span>
          <svg
            className="fill-current opacity-75 h-4 w-4"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20">
            <path d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z" />
          </svg>
        </div>
      </>
    )
  }

  const errorMessage = (text: any) => {
    return (
      <>
        <div className="mb-2"></div>
        <div
          className="p-1 text-xs rounded-full bg-red-300 items-center text-gray-800 leading-none lg:rounded-full flex lg:inline-flex"
          role="alert">
          <span className="flex mr-3">
            <XCircleIcon className="w-5 text-red-500" />
          </span>
          <span className="font-semibold mr-2 text-left flex-auto">
            {/* {errorMessage} */}
            {
              text === "Email has been registered" && "Mohon maaf email yang anda gunakan sudah terdaftar oleh orang lain"
            }
          </span>
        </div>
      </>
    )
  }

  const renderPuTableReguler = () => {
    return (
      <>
        {
          listRegReguler &&
            listRegReguler.GETS_REGISTRATION.data ?
            <>
              {
                listRegReguler.GETS_REGISTRATION.data.map((value, index) => {
                  return (
                    <div
                      key={`OldSubmission-${index}`}>
                      <CardPengajuanPu oldsubmission={value} />

                      <div className="flex flex-row space-x-3 w-full mt-5">
                        <ButtonPrimary
                          // disabled={!client}
                          loading={isFetchingReg}
                          className="w-full"
                          type="button"
                          onClick={() => doEditSelanjutnnya_reguler(value.IdReg)}
                        >
                          Selanjutnya <ArrowRightOnRectangleIcon className="font-bold ml-5 w-6" /> <br />
                        </ButtonPrimary>
                      </div>
                    </div>
                  )
                })
              }
            </>
            :
            <>
              {
                dataChecklist.GETS_DATANIBCHECKLIST.data && (
                  dataChecklist.GETS_DATANIBCHECKLIST.data.map((value, index) => {
                    if (value.dataProdukHalal.id) {
                      return (
                        <div
                          key={`dataNIBChecklist-${index}`}>
                          <CardPengajuanPu dataNIB={value} />

                          <div className="flex flex-row space-x-3 w-full mt-5">

                            <ButtonPrimary
                              // disabled={!client}
                              loading={isFetchingReg}
                              className="w-full"
                              type="button"
                              onClick={() => doOssSubmission()}
                            >
                              Selanjutnya <ArrowRightOnRectangleIcon className="font-bold ml-5 w-6" /> <br />
                            </ButtonPrimary>
                          </div>
                        </div>
                      )
                    }
                  })
                )
              }
            </>
        }
      </>
    )
  }

  const renderPuTableSelfdeclare = () => {
    return (
      <>
        {
          listRegSelfdeclare &&
            listRegSelfdeclare.GETS_REGISTRATION.data ?
            <>
              {
                listRegSelfdeclare.GETS_REGISTRATION.data.map((value, index) => {
                  return (
                    <div
                      className="rounded-xl bg-white p-3 shadow-sm mb-5"
                      key={`OldSubmission-${index}`}>
                      <CardPengajuanPu oldsubmission={value} />

                      <div className="flex justify-end flex-row space-x-3 w-full mt-1">
                        <ButtonPrimary
                          // disabled={!client}
                          loading={isFetchingReg}
                          sizeClass="py-2"
                          className="w-56"
                          type="button"
                          onClick={() => doEditSelanjutnnya_selfdeclare(value.IdReg)}
                        >
                          Selanjutnya <ArrowRightOnRectangleIcon className="font-bold ml-5 w-6" /> <br />
                        </ButtonPrimary>
                      </div>
                    </div>
                  )
                })
              }
            </>
            :
            <>
              {
                dataChecklist.GETS_DATANIBCHECKLIST.data && (
                  dataChecklist.GETS_DATANIBCHECKLIST.data.map((value, index) => {
                    if (value.dataProdukHalal.id) {
                      return (
                        <div
                          key={`dataNIBChecklist-${index}`}>
                          <CardPengajuanPu dataNIB={value} />

                          <div className="flex flex-row space-x-3 w-full mt-5">

                            <ButtonPrimary
                              // disabled={!client}
                              loading={isFetchingReg}
                              className="w-full"
                              type="button"
                              onClick={() => doOssSubmission()}
                            >
                              Selanjutnya <ArrowRightOnRectangleIcon className="font-bold ml-5 w-6" /> <br />
                            </ButtonPrimary>
                          </div>
                        </div>
                      )
                    }
                  })
                )
              }
            </>
        }
      </>
    )
  }

  if (isSuccessCreateRegSelfdeclare || isSuccessCreateRegReguler) {
    return (
      <div className={`nc-PageLogin bg-gray-100 ${className} `} data-nc-id="PageLogin">
        <div className="container h-screen flex w-full justify-center ">

          <div className="mx-auto max-w-2xl mt-10">
            <div className="rounded-xl bg-gray-50 min-full">
              <div className="rounded-xl bg-white p-5 pb-20 text-white">
                <div className="w-full flex flex-row justify-start space-x-5 items-center">
                  <img
                    className={`block max-h-16`}
                    src={logoImg}
                    alt="Logo"
                  />
                 
                </div>

              </div>

              <div className="-mt-20 p-5">
                <div className="rounded-xl bg-white p-4 font-medium text-gray-500 shadow-sm">
                  {
                    isFetchingUserInfo ? checkUserOss() :
                      <>
                        <div className="mb-3 text-sm flex flex-col justify-start">
                          <span>SELAMAT DATANG</span>
                          <span className="font-bold">{dataUserInfoOss.data.nama}</span>
                        </div>

                        <ButtonPrimary
                          // disabled={!client}
                          // loading={isFetching}
                          className="w-full"
                          // sizeClass="px-2 py-1 sm:px-1"
                          type="button"
                        // onClick={() => doSelanjutnnyya()}
                        >
                          <span className="mr-5">Muat Ulang</span>
                          <ArrowPathIcon className="aspect-square w-5 rounded-lg bg-center object-cover" />
                        </ButtonPrimary>
                      </>
                  }
                  {
                    isErrorSignUpPuOss && errorMessage(errorMessageSignUpPuOss)
                  }
                </div>
              </div>

              <section className="p-5">
                <div className="mb-5 flex items-center justify-between">
                  <h4 className="font-medium text-slate-500">Pengajuan</h4>
                  <div className="rounded-md bg-purple-100 px-2 font-semibold text-gray-900"></div>
                </div>
                <div className="space-y-2">
                  <div className="w-full max-w-sm overflow-hidden rounded-lg duration-300">
                    <svg xmlns="http://www.w3.org/2000/svg" className="mx-auto mt-8 h-16 w-16 text-green-400" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                    </svg>
                    <h1 className="mt-2 text-center text-2xl font-bold text-gray-500">Success</h1>
                  </div>
                  {/* {renderPuTableSelfdeclare()} */}
                </div>
              </section>

              <section className="p-5">
                <div className="flex flex-row space-x-3 w-full">
                  {/* <ButtonSecondary
                    // disabled={!client}
                    // loading={isFetching}
                    className="w-full"
                    type="button"
                    onClick={() => doLogout()}
                  >
                    Keluar <XCircleIcon className="font-bold ml-5 w-6" />
                  </ButtonSecondary> */}
                  <ButtonPrimary
                    // disabled={!client}
                    // loading={isFetching}
                    className="w-full"
                    type="button"
                    onClick={() => doSelanjutnnyya()}
                  >
                    Masuk ke halaman sihalal <ArrowRightOnRectangleIcon className="font-bold ml-5 w-6" /> <br />
                  </ButtonPrimary>
                </div>
              </section>

            </div>
          </div>

        </div>

      </div>
    )
  }

  return (
    <div className={`nc-PageLogin bg-gray-100 ${className} `} data-nc-id="PageLogin">
      <div className="container h-screen flex w-full justify-center ">

        <div className="mx-auto max-w-2xl mt-10">

          <div className="rounded-xl bg-gray-50 min-w-full">
            <div className="rounded-xl bg-white p-5 pb-20 text-white">
              <div className="w-full flex flex-row justify-start space-x-5 items-center">
                <img
                  className={`block max-h-16`}
                  src={logoImg}
                  alt="Logo"
                />
                <div>
                  <h1 className="text-gray-600 text-sm md:text-xl leading-4 md:leading-5 w-full flex flex-col justify-start items-start">
                    <span>
                      BADAN PENYELENGARA
                    </span>
                    <span className="font-bold">
                      JAMINAN PRODUK HALAL
                    </span>
                    <span>
                      KEMENTRIAN AGAMA RI
                    </span>
                  </h1>
                </div>
              </div>

            </div>

            <div className="-mt-20 p-5">
              <div className="rounded-xl bg-white p-4 font-medium text-gray-500 shadow-sm">
                {
                  isFetchingUserInfo ? checkUserOss() :
                    <>
                      <div className="mb-3 text-sm flex flex-col justify-start">
                        <span>SELAMAT DATANG</span>
                        <span className="font-bold">{dataUserInfoOss.data.nama}</span>
                      </div>

                      <ButtonPrimary
                        // disabled={!client}
                        // loading={isFetching}
                        className="w-full"
                        // sizeClass="px-2 py-1 sm:px-1"
                        type="button"
                      // onClick={() => doSelanjutnnyya()}
                      >
                        <span className="mr-5">Muat Ulang</span>
                        <ArrowPathIcon className="aspect-square w-5 rounded-lg bg-center object-cover" />
                      </ButtonPrimary>
                    </>
                }
                {
                  isErrorSignUpPuOss && errorMessage(errorMessageSignUpPuOss)
                }
              </div>
            </div>

            {
              isFetchingCreateDataPuNib && (<>
                <section className="p-5">
                  <div className="mb-5 flex items-center justify-start">
                    <svg
                      className="animate-spin -ml-1 mr-3 h-5 w-5"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="3"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    <h4 className="font-medium text-slate-500">Mohon tunggu</h4>
                  </div>
                </section>

              </>)
            }

            {
              !isFetchingCreateDataPuNib && isErrorCreateDataPuNIB && (
                <>
                  <section className="px-5">
                    <div className="mb-2 flex items-center justify-start">
                      <h4 className="font-medium text-slate-500">Data permohonan tidak ditemukan</h4>
                    </div>
                  </section>
                </>)
            }

            <section className="p-5">
              <div className="mb-5 flex items-center justify-between">
                <h4 className="font-medium text-slate-500"></h4>
              </div>
              <div className="space-y-2">
                {
                  !isFetchingCreateDataPuNib && dataChecklist &&
                    dataChecklist.GETS_DATANIBCHECKLIST.data &&
                    dataChecklist.GETS_DATANIBCHECKLIST.data[0].dataProdukHalal.flagSelfDeclare === "1" ? <>{renderPuTableSelfdeclare()}</> : <>{renderPuTableReguler()}</>
                }
              </div>
            </section>

          </div>
        </div>

      </div>

    </div>
  );
};

export default OssSubmission;
